import { render, staticRenderFns } from "./ScreenRecommendation.vue?vue&type=template&id=52a50a6d&scoped=true&"
import script from "./ScreenRecommendation.vue?vue&type=script&lang=js&"
export * from "./ScreenRecommendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a50a6d",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VChip,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52a50a6d')) {
      api.createRecord('52a50a6d', component.options)
    } else {
      api.reload('52a50a6d', component.options)
    }
    module.hot.accept("./ScreenRecommendation.vue?vue&type=template&id=52a50a6d&scoped=true&", function () {
      api.rerender('52a50a6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/Print/ScreenRecommendation.vue"
export default component.exports